<template>
   <div class="gens-genetictumordetection">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380_cancer-hereditary-cancer.jpg" />
             <h1 class="gens-title">{{$t('ContractText.genetic_tumor')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380_cancer-hereditary-cancer.jpg"/>
            <div slot="title">{{$t('ContractText.genetic_tumor')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('Genetictumordetection.Genetictumordetection_one')}}</div>
           <div class="tip_white">{{$t('Genetictumordetection.Genetictumordetection_two')}}</div>
       </div>

        <div class="gens_result" id="gens_content_first_right_img">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Genetictumordetection.Genetictumordetection_three')}}</div>
                       <div class="result_line"></div>
                   </div>
                  <div class="gens_content_first">
                      <div class="gens_content_first_left" v-if="$i18n.locale=='zh-CN'||$i18n.locale=='zh-TCC'">
                        
                              {{$t('Genetictumordetection.Genetictumordetection_fifty_nine')}}
                              <strong style="color: #244b6b;">{{$t('Genetictumordetection.Genetictumordetection_sixty')}}</strong>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_one')}}
                               <strong style="color: #244b6b;">{{$t('Genetictumordetection.Genetictumordetection_sixty_two')}}</strong>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_three')}}
                              <sup style="font-size: .3em;vertical-align: super;top:0em">1,2</sup>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_four')}}
                              <sup style="font-size: .3em;vertical-align: super;top:0em">3</sup>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_five')}}
                              <sup style="font-size: .3em;vertical-align: super;top:0em">4</sup>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_six')}}
  
                      </div>
                      <div class="gens_content_first_left" v-if="$i18n.locale=='en-US'">
                           {{$t('Genetictumordetection.Genetictumordetection_fifty_nine')}}
                              <strong style="color: #244b6b;">{{$t('Genetictumordetection.Genetictumordetection_sixty')}}</strong>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_one')}}
                               <strong style="color: #244b6b;">{{$t('Genetictumordetection.Genetictumordetection_sixty_two')}}</strong>
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_three')}}
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_four')}}
                              
                              <sup style="font-size: .3em;vertical-align: super;top:0em">1,2</sup>,
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_five')}}
                            
                              <sup style="font-size: .3em;vertical-align: super;top:0em">3</sup>,
                              {{$t('Genetictumordetection.Genetictumordetection_sixty_six')}} 
                               <sup style="font-size: .3em;vertical-align: super;top:0em">4</sup>.
                      </div>
                  </div>
                  <div class="gens_content_first_right">
                          <div class="gens_content_first_right_img">
                               <img src="../../assets/images/genetictumordetection/cancer_icon-45.png" />
                          </div>
                            </div>
                   </div>
                  
        </div>

        <div class="img-ss-two">
            <div class="tip_contentsd">
              <h3 class="gens-title-two">{{$t('Genetictumordetection.Genetictumordetection_fives')}}</h3>
              <h3 class="gens-title-two">{{$t('Genetictumordetection.Genetictumordetection_six')}}</h3>
            </div>
       </div>

        <div class="gens_result">
            <div class="gens_result_info" >
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Genetictumordetection.Genetictumordetection_seven')}}</div>
                    <div class="result_line"></div>
                </div>
                 <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Genetictumordetection.Genetictumordetection_eight')}}</span>
                </div>
                <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Genetictumordetection.Genetictumordetection_nine')}}</span>
                </div>
                <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Genetictumordetection.Genetictumordetection_ten')}}</span>
                </div>
                <div class="package_info">
                    <table id="cu-table" class="flush-center">
                    <caption>&nbsp;</caption>
                    <thead>
                    <tr>
                    <th id="t578811_row_0col_2" colspan="1"><span style="color: #ffffff;">{{$t('Genetictumordetection.Genetictumordetection_eleven')}}</span></th>
                    <th id="t578811_row_0col_2" colspan="1">{{$t('Genetictumordetection.Genetictumordetection_twelve')}}</th>
                    <th id="t578811_row_0col_2" colspan="1"><span style="color: #ffffff;">{{$t('Genetictumordetection.Genetictumordetection_threeteen')}}</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_fourteen')}}</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_fiveteen')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_sixteen')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_seventeen')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_eighteen')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_nineteen')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_one')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_two')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_three')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_four')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_five')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_six')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_seven')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_eight')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_twenty_nine')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_thirty')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    <tr>
                    <td><span style="color: #546c97;">●</span></td>
                    <td>{{$t('Genetictumordetection.Genetictumordetection_thirty_one')}}</td>
                    <td><span style="color: #e699b2;">●</span></td>
                    </tr>
                    </tbody>
                    </table>
                </div>
            </div>
         </div>



         <div class="gens_result special_result" id="people_topss">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Genetictumordetection.Genetictumordetection_thirty_two')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_result_science">
                       <div class="science_item science_item_special" id="s_one">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials" src="../../assets/images/genetictumordetection/cancer_icon-05.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Genetictumordetection.Genetictumordetection_thirty_three')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special " id="s_two">
                           <div class="science_item_img science_item_img_one">
                               <img class="img_science img_science_specials" src="../../assets/images/genetictumordetection/cancer_icon-06.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Genetictumordetection.Genetictumordetection_thirty_four')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special " id="s_three">
                           <div class="science_item_img science_item_img_two">
                               <img class="img_science img_science_specials" src="../../assets/images/genetictumordetection/cancer_icon-07.png" alt />   
                           </div>
                           <div class="science_abstract science_item_img_three">
                               <span class="abstract_tip">{{$t('Genetictumordetection.Genetictumordetection_thirty_five')}}</span>
                           </div>
                       </div>
                       <div class="science_item science_item_special " id="s_four">
                           <div class="science_item_img science_item_img_four">
                               <img class="img_science img_science_specials" src="../../assets/images/genetictumordetection/cancer_icon-08.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Genetictumordetection.Genetictumordetection_thirty_six')}}</span>
                           </div>
                       </div>
                       
                   </div>
            </div>
         </div>


         <div class="gens_result">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Genetictumordetection.Genetictumordetection_thirty_eight')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="advantage">
                    <div class="advantage_info">
                        <div class="advantage_info_item">
                            <div class="advantage_info_left">
                                <div class="advantage_img">
                                    <img  src="../../assets/images/genetictumordetection/cancer_icon-09.png" alt />   
                                </div>
                            </div>
                            <div class="advantage_info_right">
                                <div class="advantage_info_right_tip">{{$t('Genetictumordetection.Genetictumordetection_thirty_nine')}}</div>
                                <div class="advantate_info_right_content">{{$t('Genetictumordetection.Genetictumordetection_fourty')}}</div>
                            </div>
                        </div>
                        <div class="advantage_info_item">
                            <div class="advantage_info_left">
                                <div class="advantage_img">
                                    <img  src="../../assets/images/genetictumordetection/cancer_icon-10.png" alt />   
                                </div>
                            </div>
                            <div class="advantage_info_right">
                                <div class="advantage_info_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fourty_one')}}</div>
                                <div class="advantate_info_right_content">{{$t('Genetictumordetection.Genetictumordetection_fourty_two')}}</div>
                            </div>
                        </div>
                        <div class="advantage_info_item">
                            <div class="advantage_info_left">
                                <div class="advantage_img">
                                    <img  src="../../assets/images/genetictumordetection/cancer_icon-11.png" alt />   
                                </div>
                            </div>
                            <div class="advantage_info_right">
                                <div class="advantage_info_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fourty_three')}}</div>
                                <div class="advantate_info_right_content">{{$t('Genetictumordetection.Genetictumordetection_fourty_four')}}</div>
                            </div>
                        </div>
                        <div class="advantage_info_item">
                            <div class="advantage_info_left">
                                <div class="advantage_img">
                                    <img  src="../../assets/images/genetictumordetection/cancer_icon-12.png" alt />   
                                </div>
                            </div>
                            <div class="advantage_info_right">
                                <div class="advantage_info_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fourty_five')}}</div>
                                <div class="advantate_info_right_content">{{$t('Genetictumordetection.Genetictumordetection_fourty_six')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>


      
          <div class="gens_result_second">
               <div class="gens_result_second_info">
                   <div class="gens_result_second_info_tip">
                       <div class="gens_result_second_text">{{$t('Genetictumordetection.Genetictumordetection_fourty_seven')}}</div>
                       <div class="gens_result_second_line"></div>
                   </div>
                   <div class="gens_result_second_content">
                       <div class="content_info">
                           
                           <div class="content_info_item" >
                                <div class="img_left">
                                   <div class="img_img_left" id="img_one">
                                       <img src="../../assets/images/genetictumordetection/cancer_icon-13.png" />
                                   </div>
                               </div>
                               <div class="line_down" id="line_down_one">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right" id="text_right_one">
                                   <div class="text_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fourty_eight')}}</div>
                                   <div class="text_right_content">{{$t('Genetictumordetection.Genetictumordetection_fourty_nine')}}</div>
                               </div>
                           </div>
                           <div class="content_info_item">
                                <div class="img_left">
                                   <div class="img_img_left" id="img_two">
                                       <img src="../../assets/images/genetictumordetection/cancer_icon-14.png" />
                                   </div>
                               </div>
                               <div class="line_down" id="line_down_two">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right" id="text_right_two">
                                   <div class="text_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fifty')}}</div>
                                   <div class="text_right_content">{{$t('Genetictumordetection.Genetictumordetection_fifty_one')}}</div>
                               </div>
                           </div>
                           <div class="content_info_item" >
                                <div class="img_left">
                                   <div class="img_img_left " id="img_three">
                                       <img src="../../assets/images/genetictumordetection/cancer_icon-15.png" />
                                   </div>
                               </div>
                               <div class="line_down" id="line_down_three">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right" id="text_right_three">
                                   <div class="text_right_tip" >{{$t('Genetictumordetection.Genetictumordetection_fifty_two')}}</div>
                                   <div class="text_right_content">{{$t('Genetictumordetection.Genetictumordetection_fifty_three')}}</div>
                               </div>
                           </div>
                           <div class="content_info_item" >
                                <div class="img_left">
                                   <div class="img_img_left" id="img_four">
                                       <img src="../../assets/images/genetictumordetection/cancer_icon-16.png" />
                                   </div>
                               </div>
                               <div class="line_down" id="line_down_four">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right" id="text_right_four">
                                   <div class="text_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fifty_four')}}</div>
                                   <div class="text_right_content">{{$t('Genetictumordetection.Genetictumordetection_five')}}</div>
                               </div>
                           </div>
                           <div class="content_info_item" >
                                <div class="img_left">
                                   <div class="img_img_left" id="img_five">
                                       <img src="../../assets/images/genetictumordetection/cancer_icon-17.png" />
                                   </div>
                               </div>
                               <div class="line_down" id="line_down_five">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right" id="text_right_five">
                                   <div class="text_right_tip">{{$t('Genetictumordetection.Genetictumordetection_fifty_six')}}</div>
                                   <div class="text_right_content">{{$t('Genetictumordetection.Genetictumordetection_fifty_seven')}}</div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
        </div>
        
       
       
        <div class="gens_last_bottom">
            <div class="gens_last_bottom_content">
                <div class="bottom_document_tip">{{$t('Genetictumordetection.Genetictumordetection_fifty_eight')}}</div>
                <div class="bottom_document_cont">1. Kuchenbaecker, KB, et al. 2017; 317(23):2402-2416. doi:10.1001/jama.2017.7112.</div>
                <div class="bottom_document_cont">2. NCCN Guidelines: Genetic/Familial High Risk Assessment: Breast and Ovarian (2018. V1).</div>
                <div class="bottom_document_cont">3. NCCN Guidelines: Genetic/Familial High Risk Assessment: Colorectal (2017. V3).</div>
                <div class="bottom_document_cont">4. NCCN Guidelines: Genetic/Familial High Risk Assessment: Gastric Cancer (2017. V3).</div>
            </div>
        </div>
   
   </div>
</template>
<script>
import banner from '@/components/banner'
export default {
    data(){
        return{
           lang:this.$i18n.locale
        }
    },
    components: {
      banner,
     
    },
    mounted(){
        $(window).scroll(function(){ //滚动某位置 动画特效
        //检测鼠标滚轮距离顶部位置
       
            var box = document.querySelector(".gens_content_first_right_img");
            if( box!=null&&$(window).scrollTop()>(box.offsetTop - box.offsetHeight)){
                $('.gens_content_first_right_img').addClass('opacity');//这里840代表要动画的元素离最顶层的距离，console.log一下就知道了。
                $('.gens_content_first_right_img').addClass('rightturnleft');
            }
            var box_one= document.querySelector("#img_one");
            if( box_one!=null&&$(window).scrollTop() > (box_one.offsetTop - box_one.offsetHeight)){
                // $('.img_img_right').addClass('opacity');
                // $('.text_left_content').addClass('opacity');
                $('#line_down_one').addClass('downturntop');
                $('#line_down_two').addClass('downturntop_one');
                $('#line_down_three').addClass('downturntop_two');
                $('#line_down_four').addClass('downturntop_three');
                $('#line_down_five').addClass('downturntop_four');
                $('#text_right_one').addClass('downturntop');
                $('#text_right_two').addClass('downturntop_one');
                $('#text_right_three').addClass('downturntop_two');
                $('#text_right_four').addClass('downturntop_three');
                $('#text_right_five').addClass('downturntop_four');
                 
                // $('.img_img_left').addClass('opacity');
                $('#img_one').addClass('one_transfer');
                $('#img_two').addClass('two_transfer');
                $('#img_three').addClass('three_transfer');
                $('#img_four').addClass('four_transfer');
                $('#img_five').addClass('five_transfer');
                
            }
            var box_two= document.querySelector("#people_topss");
            if( box_two!=null&&$(window).scrollTop() > (box_two.offsetTop - box_two.offsetHeight)){
                $('#s_one').addClass('one_transfer');
                $('#s_two').addClass('two_transfer');
                $('#s_three').addClass('three_transfer');
                $('#s_four').addClass('four_transfer');

            }
            // var box_three= document.querySelector(".gens_content_img");
            // if( box_three.offsetTop!=null&&$(window).scrollTop() > (box_three.offsetTop - box_three.offsetHeight)){
            //     $('.gens_content_img').addClass('opacity');
            //     $('.gens_content_img').addClass('rightturnleft');
            // }
            
        })
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

@import '../../assets/font/iconfont.css';
@import '../../assets/css/animation.css';
.gens-genetictumordetection{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }

    .img-ss-two{
        background-image: url(../../assets/images/genetictumordetection/cancer_icon-46.jpg);
        padding-top: 60px;
        padding-bottom: 60px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        display: flex;
        .gens-img-two{
           
        }
        .tip_contentsd{
            width:1200px;
            margin:auto;
            text-align: left;
            .gens-title-two{
                    font-size: 24px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    letter-spacing: 1px;
                    margin-bottom: 24px;
                    color:#fff;
            }
        }
    }
    .gens_header_tip{
        background-color: #526e98;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #f1c480;
            text-shadow: 1px 1px 2px #244b6b;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #244b6b;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_result{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                    color: #526e98;;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #526e98;;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .result_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
             .gens_transparent_content_info{
                margin-bottom: 10px;
               
                .mytick{
                    color: #244b6b;;
                    background: 0 0;
                    border: 0;
                    font-size: 18px;
                    height: 16px;
                    width: 16px;
                    display: inline-block;
                    position: relative;
                    border:2px solid #244b6b;;
                }
                .mytick:before,.mytick:after {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    color: #244b6b;;
                    border: 2px solid #244b6b;;
                    background-color: white;
                }
                .mytick:before {
                    width: 1px;
                    height: 0px;
                    left: 18%;
                    top: 46%;
                    transform: skew(0deg, 50deg);
                }
                .mytick:after {
                    width: 11px;
                    height: 0px;
                    left: 38%;
                    top: 15%;
                    transform: skew(0deg, -50deg);
                }

                .tick_text{
                    line-height: 27px;
                    font-weight: 400;
                    margin: 0 0 0px;
                    padding: 0 0 0 18px;
                    position: relative;
                    color: #3a3a3a;
                    font-size: 16px;
                    margin-bottom: -12px;
                }
            }
             .gens_content_first{
                
                 display: flex;
                 justify-content: flex-start;
                 flex-direction: column;
                 margin-bottom:30px;
                 .gens_content_first_left{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:30px;
                        margin-right: 30px;
                 }
             }
             .gens_content_first_right{
                     width:66.66%;
                     margin-top:30px;
                     padding-bottom:30px;
                     .gens_content_first_right_img{
                         opacity: 0;
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                         img{
                             height: auto;
                             max-width: 100%;
                             width:1423px;
                         }
                     }
                     
                 }

            .gens_result_info_img{
                margin-bottom:30px;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                img{
                    vertical-align: middle;
                    height: auto;
                    max-width: 100%;
                }
            }
            .package_info{
                padding-bottom:30px;
                table{
                    border-spacing: 0;
                    display: table;
                    text-align: center;
                }
                thead {
                    display: table-header-group;

                }
                #cu-table th {
                    padding-top: 10px;
                    padding-bottom: 10px;
                    font-family: Microsoft\ JhengHei,sans-serif;
                    font-size: 16px;
                    font-weight: 600;
                    text-align: center;
                    background-color: #546c97;
                    color: #fff;
                    padding: 1.2307em 1.2307em 1em;
                }
                #cu-table td {
                    padding: .75em 1em .602em;
                    vertical-align:middle;
                    font-size: 16px;
                }
                .flush-center{
                    border: none;
                }
                #cu-table tr:nth-child(even) {
                    background-color: rgba(207,213,227,.2);
                }
                #cu-table {
                    font-family: Microsoft\ JhengHei,sans-serif;
                    border-collapse: collapse;
                    width: 100%;
                }
                caption {
                    display: table-caption;
                    text-align: -webkit-center;
                }
               
                
            }

            .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                  padding-bottom:30px;
                  min-width: 1200px;
                 .science_item{
                    width:14.66%;
                    text-align: center;
                    margin-right:20px;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:150px !important;
                        }
                        
                    }
                    
                    .science_item_img_one{
                        transition-delay: .2s;
                    }
                    .science_item_img_two{
                        transition-delay: .4s;
                    }
                    .science_item_img_three{
                        transition-delay: .6s;
                    }
                    .science_item_img_four{
                        transition-delay: .8s;
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 16px 0px 6px 0px;
                        .abstract_tip{
                           
                            font-size:16px;
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                    }

                 }
                 .science_item_special{
                    padding-left: 15px;
                    padding-right: 20px;
                   
                }
                #s_one{
                        opacity: 0;
                    }
                    #s_two{
                        opacity: 0 ;
                    }
                    #s_three{
                        opacity: 0 ;
                    }
                    #s_four{
                        opacity: 0 ;
                    }
                
                .science_item_special_std{
                    width:33.33% !important;
                    .img_science_specials{
                            width:220px !important;
                    }
                }
            }


            .advantage{
                margin-bottom:30px;
                .advantage_info{
                    display:flex;
                    flex-direction: row;
                    justify-content: space-between;
                    .advantage_info_item{
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: space-between;
                        width: 24%;
                        margin-right: 55px;
                        &:last-child{
                            margin-right: 0;
                        }
                        .advantage_info_left{
                            display: inline-block;
                            box-sizing: border-box;
                            position: relative;
                            z-index: 2;
                            min-width: 108px;
                            .advantage_img{
                                min-width: 108px;
                                img{
                                   
                                    height: auto;
                                    width:108px;
                                }
                            }
                        }
                        .advantage_info_right{
                            width:1200px;
                            box-sizing: border-box;
                              padding-bottom:18px;
                              padding-left:20px;
                              .advantage_info_right_tip{
                                  color: #244b6b;
                                  font-size: 24px;
                                    font-style: normal;
                                    font-weight: 700;
                                    text-transform: none;
                                    line-height: 1.384615384615385em;
                                    letter-spacing: 1px;
                              }
                            .advantate_info_right_content{
                                    color: #3a3a3a;
                                    font-size: 16px;
                                    line-height: 24px;
                                    font-style: normal;
                                    font-weight: 400;
                                    letter-spacing: 0.07em !important;
                            }
                        }
                      
                    }
                }
            }
           

             

         }

         .gens_list{

             display:flex;
             width:1200px;
             margin:auto;
             justify-content: flex-start;
             text-align: left;
             flex-direction: row;
             flex-wrap: wrap;
             margin-bottom:30px;
             .gens_list_item{
                 width:25%;
                 display: flex;
                 flex-direction: column;
                 .gens_list_item_single{
                     display:flex;
                     flex-direction: row;
                     margin-bottom:18px;
                    .gens_list_item_img{
                        display: inline-block;
                        position: relative;
                        z-index: 2;
                        img{
                            max-width: 100%;
                            height: auto;
                            width:52px;
                        }
                    }
                    .gens_list_item_content{
                        padding: 0 0 0 20px;
                        .gens_list_item_tip{
                            color: #15867d;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.571428571428571em;
                                                    
                            letter-spacing: 1px;
                        }
                        .gens_list_item_abstract{
                            font-size: 14px;
                            line-height: 24px;
                            color: #3a3a3a;
                            font-style: normal;
                            font-weight: 400;
                        }
                    }
                 }
             }
         }
         
    }

    .gens_result_second{
         background-color:rgba(207,213,227,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_second_info{
             width:1200px;
             margin:auto;
             .gens_result_second_info_tip{
                 .gens_result_second_text{
                        color: #526e98;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_result_second_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #526e98 ;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .gens_result_second_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
               
             }

             .gens_result_second_content{
                 text-align: center;
                 .content_info{
                     display:flex;
                     justify-content: center;
                     align-items: center;
                     flex-direction: column;
                     .content_info_item{
                         width:1200px;
                         display: flex;
                         justify-content: center;
                         flex-direction: row;
                         .text_left{
                             padding:0 60px;
                             width:50%;
                             .text_left_tip{
                                color:  #244b6b;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: right;
                             }
                             .text_left_content{
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: right;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }
                         .line_down{
                             display:flex;
                             flex-direction: column;
                             justify-content: center;
                             width: 20px;
                             padding-top:60px;
                             position: relative;
                             opacity: 0;
                             .circle{
                                 position:absolute;
                                background: #fff;
                                background-color: #526e98;
                                box-sizing: border-box;
                                border: 1px solid transparent;
                                border-radius: 50%;
                                content: "";
                                height: 18px;
                                left: 50%;
                                margin: 0 0 0 -9px;
                                position: absolute;
                                top:20px;
                                width: 18px;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.68) .5s;

                             }
                             .vertical{
                                background-color: #526e98;
                                height: 100%;
                                left: 50%;
                                margin-left: -1px;
                                position: absolute;
                                width: 2px;
                             }
                         }
                         .img_right{
                             width:50%;
                             margin-left:-10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_right{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: left;
                                box-sizing: border-box;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                             
                         }
                         .img_left{
                             width:50%;
                             margin-left:10px;
                             display:flex;
                             align-items: center;
                             justify-content: center;
                             padding-top:20px;
                             .img_img_left{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: right;
                                box-sizing: border-box;
                                margin-right:-10px;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    
                                }
                             }
                         }
                           .text_right{
                             width:50%;
                             text-align: left;
                             padding:0 0px;
                             opacity: 0;
                             .text_right_tip{
                                color: #244b6b;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: left;
                                padding-left:60px;
                                
                             }
                            .text_right_content{
                                width:100%;
                                padding-left:60px;
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: left;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }

                     }
                 }
             }
        }
    }
    

    .gens_advice{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         
        .gens_content{
            width:1200px;
            margin:auto;
            display: flex;
            justify-content: left;
            flex-direction: row;

            .gens_content_left{
                width:66.66%;
                padding-right:15px;
                .left_tips{
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    color: #5ec3b5;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                    margin-bottom:24px;

                }
                .left_advice_content{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
            }
            .gens_content_right{
                width:33.33%;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                .gens_content_img{
                    animation: fadeInRight .7s 1 ease-in-out;
                    opacity: 0;
                    img{
                        height: auto;
                        max-width: 100%;
                    }
                }
            }
        }
    }
    
    .gens_last_bottom{
        
        position: static;
        padding: 60px 0px ;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
        .gens_last_bottom_content{
            width:1200px;
            margin:auto;
            text-align: left;

            .gens_last_bottom_content_tip{
               color: #ffffff;
               font-size: 28px;
               font-style: normal;
               font-weight: 700;
               text-transform: none;
               line-height: 1.384615384615385em;
               letter-spacing: 1px;
               margin-top:60px;
            }
            .gens_last_bottom_content_tip_line{
                margin-top: 10px;
                margin-bottom: 30px;
                background-color: #ffffff;
                width: 250px;
                height: 2px;
                position: relative;

            }
            .gens_last_bottom_content_descript{
                display:flex;
                flex-direction: row;
                border-left:4px solid #5ec3b5;
                background-color: rgba(192,227,221,0.9);
                width:56.66%;
                padding-bottom:24px;
                margin-bottom:30px;
                .yinhao{
                    color: #5ec3b5;
                    font-size: 38px;
                    margin: 6px 0 0 12px !important;
                    display: inline-block;
                    font: normal normal normal 14px/1 FontAwesome;
                    letter-spacing: 0.07em !important;
                }
                .contents{
                    margin-left:40px;
                   .contents_tip{
                        color: #15867d;
                        font-size: 21px;
                        line-height: 32px;
                        letter-spacing: 0px;
                        text-transform: none;
                        font-style: normal;
                        font-weight: 300;

                   }
                   .contents_cont{
                       color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                   }
                }
            }

            .bottom_document_tip{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
            }
            .bottom_document_cont{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                
            }
            .bottom_document_cont_last{
                
            }
            
            
        }
    }


.opacity{
    opacity: 1 !important;
}

.special_result{
   background-color: rgba(207,213,227,0.2);
  
}
    
           

}
</style>

<style lang="scss">

.gens_results_right{
    .el-carousel__button{
        border-radius: 50% !important;
        width:12px !important;
        height: 12px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/genedetection/genetictumordetection.vue